import { render, staticRenderFns } from "./WelfareActiviteTwoTable.vue?vue&type=template&id=a2922220&scoped=true"
import script from "./WelfareActiviteTwoTable.vue?vue&type=script&lang=js"
export * from "./WelfareActiviteTwoTable.vue?vue&type=script&lang=js"
import style0 from "./WelfareActiviteTwoTable.vue?vue&type=style&index=0&id=a2922220&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2922220",
  null
  
)

export default component.exports